import {actions} from './action-list';
export function setSelectePanicAlertRow(value) {
    return {
        type: actions.SET_SELECTED_PANIC_ALERT_ROW,
        value: value
    }
}


